<template>
  <div class="language-score-chip" :class="`chip-variant-${variant}`">
    <span class="chip-label">{{ label }}</span>
    <span class="chip-value">{{ formattedValue }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  label: string;
  value: string | number;
  variant?: 'primary' | 'secondary';
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
});

const formattedValue = computed(() => {
  const numValue = typeof props.value === 'number' ? props.value : Number(props.value);

  if (isNaN(numValue)) {
    return props.value;
  }

  return numValue.toFixed(2);
});
</script>

<style scoped>
.language-score-chip {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 20px;
  border-radius: var(--ion-radius-lg);
  font-weight: 500;
  border: 1px solid var(--ion-input-border-color);
}

.language-score-chip.chip-variant-primary {
  background: none;
  color: var(--ion-color-primary);
}

.language-score-chip.chip-variant-secondary {
  background: var(--ion-color-primary-dark, #1a365d);
  color: white;
}

.chip-label {
  font-weight: 600;
  font-size: 13px;
}

.chip-separator {
  margin: 0 2px;
}

.chip-value {
  font-weight: 700;
  font-size: 20px;
}
</style>
